import React from "react";
import { Helmet } from "react-helmet";
import {
  greeting,
  seo,
  routeSeo,
  socialMediaLinks,
  experience,
  contactPageData,
  certifications,
  skills,
} from "../../portfolio.js";

function SeoHeader() {
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const pageSeo = routeSeo[pathname] || {};
  const pageTitle = pageSeo.title || seo.title;
  const pageDescription = pageSeo.description || seo.description;

  const canonicalUrl =
    typeof window !== "undefined"
      ? window.location.origin + window.location.pathname
      : seo?.og?.url;

  const knowsAbout = skills.data.flatMap((category) =>
    category.softwareSkills.map((skill) => skill.skillName)
  );

  let sameAs = [];
  socialMediaLinks
    .filter(
      (media) =>
        !(media.link.startsWith("tel") || media.link.startsWith("mailto"))
    )
    .forEach((media) => {
      sameAs.push(media.link);
    });

  let mail = socialMediaLinks
    .find((media) => media.link.startsWith("mailto"))
    .link.substring("mailto:".length);
  let job = experience.sections
    ?.find((section) => section.work)
    ?.experiences?.at(0);

  let credentials = [];
  certifications.certifications.forEach((certification) => {
    credentials.push({
      "@context": "https://schema.org",
      "@type": "EducationalOccupationalCredential",
      url: certification.certificate_link,
      name: certification.title,
      description: certification.subtitle,
    });
  });
  const data = {
    "@context": "https://schema.org/",
    "@type": "Person",
    name: greeting.title,
    url: seo?.og?.url,
    email: mail,
    telephone: contactPageData.phoneSection?.subtitle,
    sameAs: sameAs,
    jobTitle: job.title,
    knowsAbout: knowsAbout,
    worksFor: {
      "@type": "Organization",
      name: job.company,
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: contactPageData.addressSection?.locality,
      addressRegion: contactPageData.addressSection?.region,
      addressCountry: contactPageData.addressSection?.country,
      postalCode: contactPageData.addressSection?.postalCode,
      streetAddress: contactPageData.addressSection?.streetAddress,
    },
    hasCredential: credentials,
  };
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageSeo.title || seo?.og?.title} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={seo?.og?.type} />
      <meta property="og:url" content={canonicalUrl} />
      <link rel="canonical" href={canonicalUrl} />
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export default SeoHeader;
